import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { ThemeProvider } from '@mui/material/styles';
import { Button, Grid, CircularProgress, Typography } from '@mui/material';

import theme from '../theme';
import CustomTextField from './textfield';
import { Colors } from '../config/default';
import { createSupport, customerSignup, signUp } from '../services/services';
import { useToast } from '../toast/toastContext';
import { isEmailValid } from '../services/validationService';
import { hashEmailAndPassword } from '../services/common';
import { SUPPORT_PASSWORD } from '../constants/appConstants';
import { clearSessionPreservingTab } from '../utils/tabSession';

function CreateSupport({ setOpen, data, allusers, getAllCompanies, companyPaginationModel }) {
  const navigate = useNavigate();
  const formattedCompany = data?.companyName?.toLowerCase()?.replace(/[^a-z0-9]/g, '');
  const [email, setEmail] = useState(`${formattedCompany}@beiinghuman.com` || '');
  const [loading, setLoading] = useState(false);
  const { showToast } = useToast();

  const createSupportUserRole = async () => {
    setLoading(true);
    const params = {
      email: email?.toLowerCase(),
      role: 'Support',
      name: 'Support',
      erpUser: false,
      companyId: data?._id
    };

    const result = await createSupport(params);
    if (result?.status === 200) {
      signUpUser();
    } else if (result?.response?.status === 401) {
      clearSessionPreservingTab();
      navigate('/');
    } else {
      showToast(
        result?.data?.metadata?.message || result?.response?.data?.metadata?.message,
        'error'
      );
      setLoading(false);
    }
  };

  const signUpUser = async () => {
    const { hashedEmail, hashedPassword } = hashEmailAndPassword(
      email?.toLowerCase(),
      SUPPORT_PASSWORD
    );
    const params = {
      email: hashedEmail,
      given_name: 'Support',
      name: `${data?.companyName} Support`,
      password: hashedPassword,
      phone_number: '+10000000000',
      companyId: data?._id
    };
    const signUpResult = await signUp(params);
    if (signUpResult?.status === 200) {
      userSignUp(params, `${data?.companyName} Support`);
    } else if (signUpResult?.response?.status === 401) {
      clearSessionPreservingTab();
      navigate('/');
    } else {
      showToast(
        signUpResult?.data?.metadata?.message || signUpResult?.response?.data?.metadata?.message,
        'error'
      );
      setLoading(false);
    }
  };

  const userSignUp = async (res, name) => {
    const customerData = {
      email: res?.email,
      password: res?.password,
      userName: name,
      companyId: data?._id,
      phoneNumber: '+10000000000',
      role: 'Support',
      companyName: data?.companyName,
      name: 'Support'
    };
    const signUpRes = await customerSignup(customerData);
    if (signUpRes?.status === 200) {
      showToast('Support User Created Successfully', 'success');
      setLoading(false);
      setOpen(false);
      allusers();
      getAllCompanies(companyPaginationModel.page + 1, companyPaginationModel.pageSize);
    } else {
      showToast(
        signUpRes?.data?.metadata?.message || signUpRes?.response?.data?.metadata?.message,
        'error'
      );
      setLoading(false);
    }
  };
  return (
    <ThemeProvider theme={theme}>
      <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
        <Typography
          sx={{
            color: Colors.WHITE,
            fontWeight: 'bold',
            marginBottom: '2rem',
            fontSize: '1.2em'
          }}>
          Create Support
        </Typography>
      </Grid>
      <CustomTextField placeHolder="Support Email" setValue={setEmail} value={email} />
      <Grid
        item
        xs={12}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginTop: '1em'
        }}>
        <Button
          disabled={email === '' || !isEmailValid(email)}
          variant="contained"
          onClick={createSupportUserRole}
          sx={{
            borderRadius: '10px',
            backgroundColor: Colors.DEEPBLUE,
            color: Colors.WHITE,
            width: '6rem',
            textTransform: 'none',
            '&:hover': {
              backgroundColor: Colors.DEEPBLUE
            }
          }}>
          {loading ? <CircularProgress size={25} color="inherit" /> : 'Submit'}
        </Button>
      </Grid>
    </ThemeProvider>
  );
}

export default CreateSupport;
